<ion-app [ngClass]="getClassMap()">
  <ion-nav #navigate [root]="rootPage"></ion-nav>
  <nova-voice *ngIf="novaReady"></nova-voice>
</ion-app>
